import Vue from "vue";
import Router from "vue-router";

import Body from "@/components/body";

import Login from "@/pages/login";
import Logout from "@/pages/logout";
import Index from "@/pages/index";
import Dashboard from "@/pages/dashboard";
import Pengguna from "@/pages/pengguna";
import Config from "@/pages/config";
import Log from "@/pages/log";

import Hirarki from "@/pages/hirarki";
import masterParokiForm from "@/pages/form/paroki";
import masterWilayah from "@/pages/wilayah";
import masterWilayahForm from "@/pages/form/wilayah";
import masterStasi from "@/pages/stasi";
import masterStasiForm from "@/pages/form/stasi";

// UMAT
import baptisData from "@/pages/umat/baptis";
import baptisForm from "@/pages/umat/form/baptis";
import komuniData from "@/pages/umat/komuni";
import komuniForm from "@/pages/umat/form/komuni";
import kematianData from "@/pages/umat/kematian";
import kematianForm from "@/pages/umat/form/kematian";
import krismaData from "@/pages/umat/krisma";
import krismaForm from "@/pages/umat/form/krisma";
import perkawinanData from "@/pages/umat/perkawinan";
import perkawinanForm from "@/pages/umat/form/perkawinan";
import keluargaKatolikData from "@/pages/umat/keluargaKatolik";
import keluargaKatolikForm from "@/pages/umat/form/keluargaKatolik";
import umatData from "@/pages/umat/data";
import umatForm from "@/pages/umat/form/umat";
import umatDetail from "@/pages/umat/umatDetail";
import umatArsip from "@/pages/umat/arsip";

import umatImport from "@/pages/umat/import2";

import umatPerLingkungan from "@/pages/laporan/umatPerLingkungan";
import jumlahBaptis from "@/pages/laporan/jumlahBaptis";
import jumlahKomuni from "@/pages/laporan/jumlahKomuni";
import jumlahKrisma from "@/pages/laporan/jumlahKrisma";
import jumlahKematian from "@/pages/laporan/jumlahKematian";
import jumlahPerkawinan from "@/pages/laporan/jumlahPerkawinan";
import jumlahSingle from "@/pages/laporan/jumlahSingle";

// IURAN
import Iuran from "@/pages/iuran";

import cetak from "@/pages/laporan/cetakLingkungan";

// FORM
import PenggunaForm from "@/pages/form/pengguna";
import PenggunaPasswordForm from "@/pages/form/penggunaPassword";
import HakAksesForm from "@/pages/form/hakAkses";
// component

Vue.use(Router);

const routes = [
   {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
         title: "SIDU",
      },
   },
   {
      path: "/",
      component: Body,
      children: [
         {
            path: "dashboard",
            name: "Dashboard",
            component: Dashboard,
            meta: {
               title: "Dashboard | SIDU",
            },
         },
         {
            path: "logout",
            name: "Logout",
            component: Logout,
            meta: {
               title: "Logout | SIDU",
            },
         },
         {
            path: "config",
            name: "Config",
            component: Config,
            meta: {
               title: "Konfigurasi | SIDU",
            },
         },
         {
            path: "log",
            name: "Log",
            component: Log,
            meta: {
               title: "Log | SIDU",
            },
         },
         /* 
         ---------------------- PAROKI ---------------------- 
         */
         {
            path: "paroki",
            name: "masterParokiForm",
            component: masterParokiForm,
            meta: {
               title: "Wilayah",
            },
         },
         /* 
         ---------------------- WILAYAH ---------------------- 
         */
         {
            path: "wilayah",
            name: "masterWilayah",
            component: masterWilayah,
            meta: {
               title: "Wilayah",
            },
         },
         {
            path: "wilayah/add",
            name: "masterWilayahForm Add",
            component: masterWilayahForm,
            meta: {
               title: "Wilayah",
            },
         },
         {
            path: "wilayah/edit/:id",
            name: "masterWilayahForm Edit",
            component: masterWilayahForm,
            meta: {
               title: "Wilayah",
            },
         },
         /* 
         ---------------------- STASI ---------------------- 
         */
         {
            path: "stasi",
            name: "masterStasi",
            component: masterStasi,
            meta: {
               title: "Stasi",
            },
         },
         {
            path: "stasi/add",
            name: "masterStasiForm Add",
            component: masterStasiForm,
            meta: {
               title: "Stasi",
            },
         },
         {
            path: "stasi/edit/:id",
            name: "masterStasiForm Edit",
            component: masterStasiForm,
            meta: {
               title: "Stasi",
            },
         },

         // ---------------------- HIRARKI----------------------
         {
            path: "hirarki",
            name: "Hirarki",
            component: Hirarki,
            meta: {
               title: "Hirarki",
            },
         },

         /* 
         ---------------------------------------------------
         ---------------------- UMAT ----------------------
         --------------------------------------------------- 
         */
         // ---------------------- DATA ----------------------
         {
            path: "umat",
            name: "uamtData",
            component: umatData,
            meta: {
               title: "Umat",
            },
         },
         {
            path: "umat/add",
            name: "umatForm Add",
            component: umatForm,
            meta: {
               title: "Umat",
            },
         },
         {
            path: "umat/edit/:id",
            name: "umatForm Edit",
            component: umatForm,
            meta: {
               title: "Umat",
            },
         },
         {
            path: "umat/detail/:id",
            name: "umatDetail",
            component: umatDetail,
            meta: {
               title: "Umat",
            },
         },
         // ---------------------- BAPTIS ----------------------
         {
            path: "baptis",
            name: "baptisData",
            component: baptisData,
            meta: {
               title: "Baptis",
            },
         },
         {
            path: "baptis/add",
            name: "baptisForm Add",
            component: baptisForm,
            meta: {
               title: "Baptis",
            },
         },
         {
            path: "baptis/edit/:id",
            name: "baptisForm Edit",
            component: baptisForm,
            meta: {
               title: "Baptis",
            },
         },
         // ---------------------- KOMUNI ----------------------
         {
            path: "komuni",
            name: "komuniData",
            component: komuniData,
            meta: {
               title: "Komuni",
            },
         },
         {
            path: "komuni/add",
            name: "komuniForm Add",
            component: komuniForm,
            meta: {
               title: "Komuni",
            },
         },
         {
            path: "komuni/edit/:id",
            name: "komuniForm Edit",
            component: komuniForm,
            meta: {
               title: "Komuni",
            },
         },
         // ---------------------- KRISMA ----------------------
         {
            path: "krisma",
            name: "krismaData",
            component: krismaData,
            meta: {
               title: "Krisma",
            },
         },
         {
            path: "krisma/add",
            name: "krismaForm Add",
            component: krismaForm,
            meta: {
               title: "Krisma",
            },
         },
         {
            path: "krisma/edit/:id",
            name: "krismaForm Edit",
            component: krismaForm,
            meta: {
               title: "Krisma",
            },
         },
         // ---------------------- PERKAWINAN ----------------------
         {
            path: "perkawinan",
            name: "perkawinanData",
            component: perkawinanData,
            meta: {
               title: "Perkawinan",
            },
         },
         {
            path: "perkawinan/add",
            name: "perkawinanForm Add",
            component: perkawinanForm,
            meta: {
               title: "Perkawinan",
            },
         },
         {
            path: "perkawinan/edit/:id",
            name: "perkawinanForm Edit",
            component: perkawinanForm,
            meta: {
               title: "Perkawinan",
            },
         },
         // ---------------------- KEMATIAN ----------------------
         {
            path: "kematian",
            name: "kematianData",
            component: kematianData,
            meta: {
               title: "Kematian",
            },
         },
         {
            path: "kematian/add",
            name: "kematianForm Add",
            component: kematianForm,
            meta: {
               title: "Kematian",
            },
         },
         {
            path: "kematian/edit/:id",
            name: "kematianForm Edit",
            component: kematianForm,
            meta: {
               title: "Kematian",
            },
         },
         // ---------------------- KELUARGA KATOLIK ----------------------
         {
            path: "Keluarga_katolik",
            name: "keluargaKatolikData",
            component: keluargaKatolikData,
            meta: {
               title: "Keluarga Katolik",
            },
         },
         {
            path: "Keluarga_katolik/add",
            name: "keluargaKatolikForm Add",
            component: keluargaKatolikForm,
            meta: {
               title: "Keluarga Katolik",
            },
         },
         {
            path: "Keluarga_katolik/edit/:id",
            name: "keluargaKatolikForm Edit",
            component: keluargaKatolikForm,
            meta: {
               title: "Keluarga Katolik",
            },
         },
         {
            path: "umat_import",
            name: "umatImport Form",
            component: umatImport,
            meta: {
               title: "Import Umat",
            },
         },
         {
            path: "umat_arsip",
            name: "umatArsip",
            component: umatArsip,
            meta: {
               title: "Arsip",
            },
         },
         // ---------------------- LAPORAN----------------------
         {
            path: "laporan/jumlah/umat",
            name: "umatPerLingkungan",
            component: umatPerLingkungan,
            meta: {
               title: "Jumlah Umat/KK",
            },
         },
         {
            path: "laporan/jumlah/baptis",
            name: "jumlahBaptis",
            component: jumlahBaptis,
            meta: {
               title: "Jumlah Baptis",
            },
         },
         {
            path: "laporan/jumlah/komuni",
            name: "jumlahKomuni",
            component: jumlahKomuni,
            meta: {
               title: "Jumlah Komuni",
            },
         },
         {
            path: "laporan/jumlah/krisma",
            name: "jumlahKrisma",
            component: jumlahKrisma,
            meta: {
               title: "Jumlah Krisma",
            },
         },
         {
            path: "laporan/jumlah/perkawinan",
            name: "jumlahPerkawinan",
            component: jumlahPerkawinan,
            meta: {
               title: "Jumlah Perkawinan",
            },
         },
         {
            path: "laporan/jumlah/kematian",
            name: "jumlahKematian",
            component: jumlahKematian,
            meta: {
               title: "Jumlah Kematian",
            },
         },
         {
            path: "laporan/jumlah/single",
            name: "jumlahSingle",
            component: jumlahSingle,
            meta: {
               title: "Jumlah Single Parent",
            },
         },
         {
            path: "laporan/cetak",
            name: "laporanCetak",
            component: cetak,
            meta: {
               title: "Cetak per Lingkungan",
            },
         },
         // ---------------------- PENGGUNA----------------------
         {
            path: "pengguna",
            name: "Pengguna",
            component: Pengguna,
            meta: {
               title: "Pengguna | SIDU",
            },
         },
         {
            path: "pengguna/add",
            name: "PenggunaForm Add",
            component: PenggunaForm,
            meta: {
               title: "Pengguna | SIDU",
            },
         },
         {
            path: "pengguna/hakakses/:id",
            name: "HakAksesForm",
            component: HakAksesForm,
            meta: {
               title: "Pengguna - Hak Akses | SIDU",
            },
         },
         {
            path: "pengguna/edit/:id",
            name: "PenggunaForm Edit",
            component: PenggunaForm,
            meta: {
               title: "Pengguna | SIDU",
            },
         },
         {
            path: "pengguna/change_password/:id",
            name: "PenggunaForm Ganti Password",
            component: PenggunaPasswordForm,
            meta: {
               title: "Pengguna Ganti Password | SIDU",
            },
         },
         // ---------------------- PENGGUNA----------------------

         // ---------------------- IURAN ----------------------
         {
            path: "iuran",
            name: "Iuran KK",
            component: Iuran,
            meta: {
               title: "Iuran KK",
            },
         },
      ],
   },
   {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
         title: "Login | SIDU",
      },
   },
];

const router = new Router({
   routes,
   base: "/",
   mode: "history",
   linkActiveClass: "active",
   scrollBehavior() {
      return { x: 0, y: 0 };
   },
});

router.beforeEach((to, from, next) => {
   // const user = Vue.$store.state.auth.user;
   let publicPages = ["/login", "/"];
   // if (user.group === "Admin"){
   //    publicPages = ["/login"];
   // } else if (user.group === "Kasir") {
   //    publicPages = ["/login"];
   // } else if (user.group === "Admin") {
   //    publicPages = ["/login"];
   // }

   const authRequired = !publicPages.includes(to.path);
   const loggedIn = localStorage.getItem("user");

   // trying to access a restricted page + not logged in
   // redirect to login page
   if (authRequired && !loggedIn) {
      next("/");
   } else {
      next();
   }
});

export default router;
